import { render, staticRenderFns } from "./MarkCounter.vue?vue&type=template&id=34f43280&scoped=true&"
import script from "./MarkCounter.vue?vue&type=script&lang=js&"
export * from "./MarkCounter.vue?vue&type=script&lang=js&"
import style0 from "./MarkCounter.vue?vue&type=style&index=0&id=34f43280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f43280",
  null
  
)

export default component.exports